import { useTranslation } from "react-i18next";

import colorSchemeCool from "~/assets/svg/onboarding-flow-color-scheme-cool.svg";
import colorSchemeEarthy from "~/assets/svg/onboarding-flow-color-scheme-earthy.svg";
import colorSchemeWarm from "~/assets/svg/onboarding-flow-color-scheme-warm.svg";
import colorSchemeNeutral from "~/assets/svg/onboarding-flow-color-scheme-neutral.svg";

import {
  Container,
  Label,
  LabelContainer,
  LabelDescription,
  LabelImage,
} from "./styles";
import { Radio } from "../radio";
import { IOnboardingChoices } from "~/types/account";
import { Dispatch, SetStateAction } from "react";
import { useMediaQuery } from "~/hooks/useMediaQuery";

export const COLOR_SCHEME_ARRAY = [
  {
    // Color scheme: Cool
    id: "cool",
    label: "onboarding.customization-store.color-scheme-step.radio-cool",
    description:
      "onboarding.customization-store.color-scheme-step.radio-cool-description",
    image: colorSchemeCool,
  },
  {
    // Color scheme: Warm
    id: "warm",
    label: "onboarding.customization-store.color-scheme-step.radio-warm",
    description:
      "onboarding.customization-store.color-scheme-step.radio-warm-description",
    image: colorSchemeWarm,
  },
  {
    // Color scheme: Earthy
    id: "earthy",
    label: "onboarding.customization-store.color-scheme-step.radio-earthy",
    description:
      "onboarding.customization-store.color-scheme-step.radio-earthy-description",
    image: colorSchemeEarthy,
  },
  {
    // Color scheme: Neutral
    id: "neutral",
    label: "onboarding.customization-store.color-scheme-step.radio-neutral",
    description:
      "onboarding.customization-store.color-scheme-step.radio-neutral-description",
    image: colorSchemeNeutral,
  },
];

type ColorSchemeProps = {
  onboardingChoices: IOnboardingChoices | undefined;
  setOnboardingChoices: Dispatch<
    SetStateAction<IOnboardingChoices | undefined>
  >;
};

export const ColorScheme = ({
  onboardingChoices,
  setOnboardingChoices,
}: ColorSchemeProps) => {
  const { t } = useTranslation();
  const isAboveMobile = useMediaQuery("mobileL");

  const handleChangeColorScheme = (selectedColorScheme: string) => {
    setOnboardingChoices((prev) => ({
      ...prev,
      selectedColorScheme,
    }));
  };

  return (
    <Container data-testid="onboarding-color-scheme">
      {COLOR_SCHEME_ARRAY.map((colorScheme) => {
        const { id: colorSchemeId, label, image, description } = colorScheme;
        const checked =
          colorSchemeId === onboardingChoices?.selectedColorScheme;

        return (
          <Radio
            context="store-color-scheme-selection"
            key={`store-color-scheme-selection-${colorSchemeId}`}
            optionId={colorSchemeId}
            checked={checked}
            label={t(label)}
            changeSelectedOption={handleChangeColorScheme}
            hasUniqueLabel
            isFullWidth={!isAboveMobile}
            uniqueLabel={
              <LabelContainer>
                <LabelImage src={image} alt={`radio-image-${colorSchemeId}`} />
                <Label checked={checked}>
                  {t(label)}
                  <LabelDescription checked={checked}>
                    {t(description)}
                  </LabelDescription>
                </Label>
              </LabelContainer>
            }
          />
        );
      })}
    </Container>
  );
};
